// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3qjcH","type":"styles_type__3H9bG","choices":"styles_choices__2qOAM"};